import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Storages from '../helper/storages';
import paths from './../config/paths.json'

function PublicRoute() {
    const auth = Storages.getUserToken(); // determine if authorized, from context or however you're doing it
    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return (auth && auth != undefined && auth != 'undefined') ? <Navigate to={paths.dashboard} /> : <Outlet />;
}

export default PublicRoute